import React from "react";
import { useCanvasStore } from "store/CanvasStore";
import { styles } from "./styles";
import { setCanvasSize } from "helpers/mathFunctions";

const PausedOverlay: React.FC = () => {
  const { isBuilding, showBuild, canvasObj } = useCanvasStore();
  const { height, width, scale } = setCanvasSize();
  const showCondition = !isBuilding && !showBuild && canvasObj?.paused;

  if (!showCondition) {
    return <></>;
  }

  return (
    showCondition && (
      <div
        style={{
          ...styles.pausedOverlay,
          height,
          // width - GameControls Witdh * Scale - GameControlsPadding
          width: width - 350 * scale - 80,
        }}
      >
        <h2>Game Paused</h2>
      </div>
    )
  );
};

export default PausedOverlay;
